import { createFileRoute } from '@tanstack/react-router'
import { GroupTags } from '@/components/settings-route/tags'

export const Route = createFileRoute('/_auth/settings/tags/')({
  component: GroupTags,
})
